/* Cats Garage — product-gallery.js
   Thumbnail click swaps the main PDP image; "+N" tile reveals hidden thumbs.
   Vanilla JS, loaded with defer. Without JS the featured image simply stays. */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-thumbs-more]');
    if (more) {
      var galleryEl = more.closest('[data-cg-gallery]');
      if (!galleryEl) return;
      galleryEl.querySelectorAll('[data-thumb][hidden]').forEach(function (thumb) {
        thumb.removeAttribute('hidden');
      });
      more.setAttribute('hidden', '');
      return;
    }

    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-cg-gallery]');
    var main = gallery && gallery.querySelector('[data-main-image]');
    if (!main || !thumb.getAttribute('data-full')) return;

    main.removeAttribute('srcset');
    main.src = thumb.getAttribute('data-full');
    if (thumb.hasAttribute('data-alt')) main.alt = thumb.getAttribute('data-alt');

    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });
})();
